import { Component, OnInit, Input, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StudioTemplateConfigurations } from '../../configs/studio-template-configs';

import { ProductPublicModels } from '@features/products/product';
import { Resolutions } from '@layout/domain/models/layout.models';
import { getResolution } from '@layout/infrastructure/state/layout.selectors';
import { getCatalogStyles } from '@pages/category/store/category-page.selectors';
import { ProductViewConfig, CategoryConfiguration, GridProductStyle } from '@shared/product/models';

@Component({
    selector: 'studio-nsla-template',
    templateUrl: './studio-nsla-template.component.html',
})

export class StudioNslaTemplateComponent implements OnInit {
    @Input() public categoryId: string;

    @Input() public products: number[];

    @Input() public categoryConfiguration: CategoryConfiguration;

    @Input() public templateName: string;

    @Input() public place: string;

    @Input() public elementIndex: number;

    @Input() public elementDefaultImageTypes: Map<number, string>;

    @Input() public productStyle: GridProductStyle;

    public templateNameFirst: string;

    public readonly clickAddToCart = output<ProductPublicModels.PublicProduct>();

    public isMobile$: Observable<boolean> = this.store.select(getResolution)
        .pipe(map((resolution) => resolution === Resolutions.MOBILE));

    public templateConfiguration$: Observable<ProductViewConfig> = this.store.select(getCatalogStyles).pipe(
        map((catalogStyles: Record<string, string>) => {
            const templateConfig = this.studioTemplateConfigurations.getStudioTemplateConfig(this.templateName);
            const styles = {
                backgroundColor: catalogStyles?.backgroundColor,
                fontColor: catalogStyles?.fontColor,
                offerPrice: catalogStyles?.offerPrice,
                colorSelector: catalogStyles?.colorSelector,
                cardColor: catalogStyles?.backgroundColor,
            };

            templateConfig.showMediaCarousel = false;

            return {
                ...templateConfig,
                styles,
            };
        })
    );

    public clickActive = true;

    constructor(
        private readonly store: Store,
        private readonly studioTemplateConfigurations: StudioTemplateConfigurations,
    ) { }

    public ngOnInit(): void {
        this.getTemplatePrefix();
    }

    public getTemplatePrefix(): void {
        const parts = this.templateName.split('_');
        this.templateNameFirst = parts.length > 1 ? parts[0] : this.templateName;
    }

    public setClickActive(clickActive: boolean): void {
        this.clickActive = clickActive;
    }

    public addToCartSheet({ product }) {
        this.clickAddToCart.emit(product);
    }
}
